
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"22","fill":"none","stroke":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.143 7.667V5.444c0-1.178-.542-2.309-1.507-3.142C12.672 1.468 11.364 1 10 1c-1.364 0-2.672.468-3.637 1.302-.964.833-1.506 1.964-1.506 3.142v2.223M17.714 21H2.286c-.341 0-.668-.117-.91-.325A1.04 1.04 0 011 19.889V8.778c0-.295.135-.578.377-.786.24-.208.568-.325.909-.325h15.428c.341 0 .668.117.91.325.24.208.376.491.376.786v11.11c0 .296-.136.578-.377.787a1.395 1.395 0 01-.909.325z","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    